import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Output,
  Input,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../Service/api.service';
import { CommonStandaloneImports } from '../common/common-standalone-imports';
import { CallSocketService } from '../../Service/call-socket.service';
import { AmbNotificationComponent } from '../amb-notification/amb-notification.component';
import { NotificationCountService } from '../../Service/notification-count.service';

@Component({
  standalone: true,
  selector: 'app-header',
  imports: [...CommonStandaloneImports, AmbNotificationComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  hideSearch: boolean = false;
  notifCount: any;
  storePreviousCount: number = 0;
  notificationLists: any;
  closeTimeout: number | undefined;
  showNotifications: boolean = false;
  private notificationAudio = new Audio('/assets/audio/short_and_quiet.mp3');
  constructor(
    private notificationService: ApiService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private socketService: CallSocketService,
    private notificationCountService: NotificationCountService,
  ) {
    const url = this.router.url;
    if (url.includes('detail-dashboard')) {
      this.hideSearch = true;
    } else {
      this.hideSearch = false;
    }

    this.notificationCountService.notifCount$.subscribe((count) => {
      this.notifCount = count;
      // this.cdr.detectChanges();
    });

    this.handleNotificationsEvent();
    this.getRecentNotifications();
  }
  @Input() searchText: string = '';
  @Output() searchTextChanged = new EventEmitter<string>();

  getRecentNotifications(playAudio: boolean = false) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = user.user_id;

    this.notificationService.getRecentNotifications(userId).subscribe({
      next: (response: any) => {
        const unreadNotifications = (response?.data || []).filter(
          (notif: any) => notif.is_read === 1,
        );

        this.notifCount = unreadNotifications.length;
        this.notificationCountService.setCount(this.notifCount);
        this.notificationLists = response?.data || [];

        if (this.notifCount > this.storePreviousCount) {
          playAudio && this.notificationAudio.play().catch(() => {});
          this.storePreviousCount = this.notifCount;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching notifications:', error);
      },
    });
  }

  handleNotificationsEvent() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = user.user_id;
    this.socketService.connect(userId);
    this.socketService.notificationCount.subscribe((resp) => {
      if (resp) {
        this.getRecentNotifications(true);
      }
    });
  }
  onQuickFilterChanged(event: Event) {
    localStorage.removeItem('doctor_currentRowIndex');
    const value = (event.target as HTMLInputElement).value;
    this.searchTextChanged.emit(value);
  }

  openNotifications(state: boolean) {
    if (state) {
      clearTimeout(this.closeTimeout);
      this.showNotifications = true;
    } else {
      this.closeTimeout = setTimeout(() => {
        this.showNotifications = false;
      }, 180);
    }
  }

  moveToHome() {
    this.router.navigate(['/Dashboard/doctor-dashboard']);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.socketService.disconnectSession();
  }

  ngOnDestroy() {
    this.socketService.disconnectSession();
  }
}
